import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { Menu, X, Phone } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-94">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-95">
        <div className="flex items-center justify-between" data-id="element-96">
          {/* Logo */}
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => scrollToSection('hero')} data-id="element-97">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-600 text-white font-bold text-xl" data-id="element-98">
              A
            </div>
            <span className={`text-xl font-bold tracking-tight ${isScrolled ? 'text-slate-900' : 'text-slate-900'}`} data-id="element-99">
              AMK<span className="text-blue-600" data-id="element-100">Solutions</span>
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-101">
            {['Services', 'Why Us', 'Industries', 'About'].map(item => <button key={item} onClick={() => scrollToSection(item.toLowerCase().replace(' ', '-'))} className="text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors" data-id="element-102">
                {item}
              </button>)}
            <Button variant="primary" size="sm" onClick={() => scrollToSection('contact')} className="ml-4" data-id="element-103">
              Get Started
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-slate-600" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-104">
            {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-105" /> : <Menu className="h-6 w-6" data-id="element-106" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-white border-b border-slate-100 shadow-lg md:hidden p-4 flex flex-col gap-4" data-id="element-107">
          {['Services', 'Why Us', 'Industries', 'About'].map(item => <button key={item} onClick={() => scrollToSection(item.toLowerCase().replace(' ', '-'))} className="text-left text-base font-medium text-slate-600 py-2 hover:text-blue-600" data-id="element-108">
              {item}
            </button>)}
          <Button onClick={() => scrollToSection('contact')} className="w-full" data-id="element-109">
            Get Started
          </Button>
        </div>}
    </header>;
}